module.exports = __webpack_public_path__ + "img/heqing1.a4e2ff36.png";